import { useEffect } from "react";
import { useSeoContext } from "../context/SeoContext";

/**
 * Override route-level SEO for the current page (e.g. dynamic blog posts).
 * Cleared automatically on unmount.
 */
export function usePageSeo(seo) {
    const { setPageSeo } = useSeoContext();

    useEffect(() => {
        setPageSeo(seo || null);
        return () => setPageSeo(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- granular fields avoid object reference churn
    }, [
        seo?.title,
        seo?.description,
        seo?.keywords,
        seo?.canonical,
        seo?.ogImage,
        seo?.ogType,
        seo?.noindex,
        seo?.article?.title,
        seo?.article?.description,
        seo?.article?.datePublished,
        seo?.article?.author,
        setPageSeo,
    ]);
}
